module.exports = __webpack_public_path__ + "static/media/bg_trial_resumption_from_35_to_39.123cf01d.webp";